import types from './types';

const initialState = {
  locale: localStorage.getItem('app-locale'),
};

function intlReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.CHANGE_SYSTEM_LOCALE:
      localStorage.setItem('app-locale', payload.locale);

      return { ...state, locale: payload.locale };
    default:
      return state;
  }
}

export default intlReducer;
